(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealSelector = [
    'main h1',
    'main h2',
    'main .title',
    'main .title-wrapper',
    'main .card-wrapper',
    'main .article-card-wrapper',
    'main .collection-card-wrapper',
    'main article',
    'main .product__info-container',
    'main .product__media-wrapper',
    'main .banner__content',
    'main .rich-text__blocks',
  ].join(',');

  const surfaceSelector = [
    'main .card-wrapper',
    'main .article-card-wrapper',
    'main .collection-card-wrapper',
    'main [class*="__card"]',
    'main [class*="__media"]',
    'main [class*="__art"]',
    'main [class*="__stage"]',
  ].join(',');

  let observer = null;
  let initialized = false;
  let headerUpdateScheduled = false;

  function isUsefulTarget(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (element.closest('.global-floating-tools, .shopify-section-header, .shopify-section-footer')) return false;
    if (element.matches('script, style, noscript, template, input, textarea, select, button, svg')) return false;
    return true;
  }

  function markRevealTargets(root) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) return;
    const targets = Array.from((root || document).querySelectorAll(revealSelector)).filter(isUsefulTarget);

    targets.forEach((element, index) => {
      if (element.classList.contains('brand-reveal')) return;
      element.classList.add('brand-reveal');
      element.style.setProperty('--brand-reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
      observer.observe(element);
    });
  }

  function markHoverSurfaces(root) {
    Array.from((root || document).querySelectorAll(surfaceSelector))
      .filter(isUsefulTarget)
      .forEach((element) => {
        if (element.closest('.global-promo-modal, .global-floating-tools')) return;
        const signalTarget = element.matches('.media, [class*="__media"], [class*="__art"], [class*="__stage"]')
          ? element
          : element.querySelector('.media, [class*="__media"], [class*="__art"], [class*="__stage"]');
        const hasVisual = Boolean(signalTarget && signalTarget.querySelector('img, picture, video, .media'));
        const hasCommerceLink = Boolean(element.matches('.card-wrapper, .article-card-wrapper, .collection-card-wrapper'));

        if (!hasVisual && !hasCommerceLink) return;
        element.classList.add('brand-elevated-surface');

        if (hasVisual && signalTarget instanceof HTMLElement) {
          signalTarget.classList.add('brand-signal-surface');
        }
      });
  }

  function initObserver() {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12,
      }
    );
  }

  function updateHeaderState() {
    headerUpdateScheduled = false;
    document.documentElement.classList.toggle('brand-has-scrolled', window.scrollY > 10);
  }

  function scheduleHeaderUpdate() {
    if (headerUpdateScheduled) return;
    headerUpdateScheduled = true;
    window.requestAnimationFrame(updateHeaderState);
  }

  function init(root) {
    markHoverSurfaces(root);
    markRevealTargets(root);
    updateHeaderState();
  }

  function boot() {
    if (initialized) return;
    initialized = true;
    initObserver();
    init(document);
    window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
